import { render } from "./SinglePoc.vue?vue&type=template&id=53313d70&scoped=true"
import script from "./SinglePoc.vue?vue&type=script&lang=js"
export * from "./SinglePoc.vue?vue&type=script&lang=js"

import "./SinglePoc.vue?vue&type=style&index=0&id=53313d70&lang=css&scoped=true"
import "./SinglePoc.vue?vue&type=style&index=1&id=53313d70&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53313d70"]])

export default __exports__